import styled, { css } from 'styled-components'

import { Button, CircularLoader } from '@blade/ui-kit'

import type { TradeType } from '@root/entities/trade-type'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  swapDirection: TradeType.SwapDirection
  children: React.ReactNode
  onClick: () => void
  disabled: boolean
  busy: boolean
} & ClassNameProps

export const SwapButton: React.FC<Props> = ({
  swapDirection,
  children,
  onClick,
  disabled,
  busy,
  className,
}) => (
  <Root
    variant="secondary"
    radius="rounded"
    onClick={onClick}
    disabled={disabled}
    $type={swapDirection}
    className={className}
  >
    {busy ? (
      <CircularLoader
        size={16}
        color={swapDirection === 'sell' ? 'downAccent' : 'upAccent'}
      />
    ) : (
      children
    )}
  </Root>
)

const Root = styled(Button)<{ $type: TradeType.SwapDirection }>`
  height: 37px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  width: 100%;

  &:disabled {
    color: var(--text-7);
    border: 1px solid var(--background-4);
    background: transparent;
  }

  ${({ $type }) => {
    const isSell = $type === 'sell'
    const color = isSell ? 'var(--downAccent-9)' : 'var(--upAccent-9)'
    const background = isSell
      ? 'rgba(var(--downAccent-9-rgb), 0.1)'
      : 'rgba(var(--upAccent-9-rgb), 0.1)'
    const border = isSell
      ? '1px solid rgba(var(--downAccent-9-rgb), 0.4)'
      : '1px solid rgba(var(--upAccent-9-rgb), 0.4)'

    return css`
      color: ${color};
      background: ${background};
      border: ${border};

      &:hover:not(:disabled) {
        color: ${color};
        background: ${background};
        border: ${border};
      }
    `
  }}
`
